import { NgModule } from "@angular/core";
import { DisableMKeyboardDirective } from "./disable-mkeyboard";

@NgModule({
	declarations: [DisableMKeyboardDirective],
	exports: [DisableMKeyboardDirective]
})
export class DirectiveModule {}
